import { render } from "./RKETemplateName.vue?vue&type=template&id=1471a8a9&scoped=true"
import script from "./RKETemplateName.vue?vue&type=script&lang=js"
export * from "./RKETemplateName.vue?vue&type=script&lang=js"

import "./RKETemplateName.vue?vue&type=style&index=0&id=1471a8a9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1471a8a9"]])

export default __exports__